export class LzOutWindow {
    buffer = null;
    pos = 0;
    streamPos = 0;
    stream = null;
    windowSize = 0;
    // Private Go-style properties
    w = null;
    buf = [];
    constructor(writer = null, windowSize = 4096) {
        this.w = writer;
        this.stream = writer;
        this.windowSize = windowSize;
        this.buf = new Array(windowSize);
        this.buffer = this.buf;
        this.pos = 0;
        this.streamPos = 0;
    }
    /**
     * Copy a block of data from a previous position (LZ77-style)
     */
    copyBlock(distance, length) {
        if (!this.buffer)
            return;
        for (let i = 0; i < length; i++) {
            // Get byte from previous position
            let sourcePos = this.pos - distance - 1;
            if (sourcePos < 0) {
                sourcePos += this.windowSize;
            }
            const byte = this.buffer[sourcePos];
            this.putByte(byte);
        }
    }
    /**
     * Put a single byte into the window
     */
    putByte(byte) {
        if (!this.buffer)
            return;
        this.buffer[this.pos] = byte;
        this.pos++;
        this.streamPos++;
        if (this.pos >= this.windowSize) {
            this.flush();
        }
    }
    /**
     * Get a byte from a relative position
     */
    getByte(relativePos) {
        if (!this.buffer)
            return 0;
        let pos = this.pos + relativePos;
        if (pos < 0) {
            pos += this.windowSize;
        }
        else if (pos >= this.windowSize) {
            pos -= this.windowSize;
        }
        return this.buffer[pos];
    }
    /**
     * Flush buffered data to output writer
     */
    flush() {
        if (this.w && this.buffer && this.pos > 0) {
            const dataToWrite = this.buffer.slice(0, this.pos);
            this.w.write(dataToWrite);
            this.pos = 0;
        }
    }
    /**
     * Check if the window is empty
     */
    isEmpty() {
        return this.streamPos === 0;
    }
    /**
     * Reset the window
     */
    reset() {
        this.pos = 0;
        this.streamPos = 0;
        if (this.buffer) {
            this.buffer.fill(0);
        }
    }
}
